import { ActionTree } from "vuex";
import { RootState } from "..";
import { State } from "./state";
import { MutationTypes } from "./mutations";
import recoveryAgentService from "@/services/recovery-agent.service";

export enum ActionTypes {
  FetchAgents = "FETCH_AGENTS",
  RemoveAgent = "REMOVE_AGENT",
  CreateAgent = "CREATE_AGENT"
}

export const actions: ActionTree<State, RootState> = {
  async [ActionTypes.FetchAgents]({ commit }) {
    const devices = await recoveryAgentService.getActive();
    commit(MutationTypes.SetAgents, devices);
  },
  async [ActionTypes.RemoveAgent]({ commit }, agentEmail: string) {
    const output = await recoveryAgentService.remove(agentEmail);
    if (output) {
      commit(MutationTypes.RemoveAgent, agentEmail);
      return true;
    }
  },
  async [ActionTypes.CreateAgent]({ commit }, agent: any) {
    const output = await recoveryAgentService.create(agent);
    if (output) {
      commit(MutationTypes.AddAgent, agent);
      return true;
    }
  },
};
